/**
 * Marca de monitoramento ao vivo. O ponto pulsa, e o texto "Ao vivo" carrega
 * o significado — cor e movimento não são o único sinal.
 */
export function SeloAoVivo() {
  return (
    <span className="inline-flex items-center gap-2 rounded-full bg-secondary px-3 py-1 text-sm font-medium text-ok">
      <span aria-hidden="true" className="size-2 shrink-0 rounded-full bg-ok motion-safe:animate-pulse" />
      Ao vivo
    </span>
  );
}
